import React from 'react';
import TouchProvider from 'signer-app/parts/touch-provider';
import SignatureProviderImpl from 'signer-app/signature-modal/signature-modal-context/signature-provider-impl';
import SignerContext from 'signer-app/signer-signature-document/context';
import { SignatureRequest } from 'signer-app/signer-signature-document/types';
import SignatureProviderIntercept from 'signer-app/signature-modal/signature-modal-context/signature-provider-intercept';
import { defaultEsignDisclosure } from 'signer-app/context/signer-app-client/signer-api-mock';
import { Field } from 'signer-app/types/editor-types';

type Props = {
  signatureRequest: SignatureRequest;
  children: React.ReactNode;
  requestTitle?: string;
  startEnabled?: boolean;
  onFieldUpdate?: (field: Field, updates: Partial<Field>) => void;
  selectedFieldIds?: string[];
  setCurrentField?: (id: string | null) => void;
  dateFormat?: string;
  getInstantValidationErrorHack?: (id: string) => void;
  inlinePreviewMode?: boolean;
  lastUpdatedFieldId?: string;
  fieldResetKey?: string;
};

export function SignerPreviewExperience({
  children,
  signatureRequest,
  requestTitle = '',
  startEnabled = true,
  onFieldUpdate = () => {},
  selectedFieldIds = [],
  setCurrentField = () => {},
  dateFormat = 'MM/DD/YYYY',
  getInstantValidationErrorHack = () => {},
  inlinePreviewMode = false,
  lastUpdatedFieldId = '',
  fieldResetKey = '',
}: Props) {
  const requestKey = React.useMemo(
    () => Math.random().toString(36),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return (
    <SignatureProviderImpl
      hideSpinner={true}
      key="this-needs-a-stable-key-because-remounts-refetch"
      isMobile={false}
      isDropbox={false}
      firstName={'FirstName'}
      lastName={'LastName'}
      primarySignatureGuid={''}
      isEmbedded={false}
      canInsertEverywhere={false}
      allowColorSig={false}
      allowedSignatureTypes={{
        S: true,
        C: true,
        T: true,
        U: true,
        E: true,
        ERROR: false,
      }}
      defaultSignatureType={'C'}
    >
      <SignatureProviderIntercept>
        <TouchProvider>
          <SignerContext
            key={requestKey}
            uploadAttachment={() => {}}
            allowReassign={false}
            allowDecline={false}
            esignDisclosure={defaultEsignDisclosure}
            isComingFromSmsDelivery={false}
            transmissionGuid="tsm-guid"
            esignDisclosureOptIn={() => {}}
            requestTitle={requestTitle}
            validationErrors={{}}
            documentPreview={true}
            fieldResetKey={fieldResetKey}
            startEnabled={startEnabled}
            onFieldUpdate={onFieldUpdate}
            selectedFieldIds={selectedFieldIds}
            setCurrentField={(id) => setCurrentField(id)}
            signatureRequest={signatureRequest}
            defaultDateFormat={dateFormat}
            getInstantValidationErrorHack={getInstantValidationErrorHack}
            inlinePreviewMode={inlinePreviewMode}
            lastUpdatedFieldId={lastUpdatedFieldId}
            finalize={() => {}}
            isQualifiedSignature={false}
          >
            {children}
          </SignerContext>
        </TouchProvider>
      </SignatureProviderIntercept>
    </SignatureProviderImpl>
  );
}
